export const contactPageData = {
  contactSection: {
    title: 'Contact Me',
    profile_image_path: 'animated_ashutosh.png',
    description:
      'I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Web Development.',
  },
  addressSection: {
    title: 'Address',
    subtitle:
      'Block 8 Lot 38 Franchise St. BIR Village, West Fairview, Quezon City',
    avatar_image_path: 'address_image.svg',
    location_map_link: 'https://goo.gl/maps/4cvqkCND6DdwDU9K8',
  },
  phoneSection: {
    title: 'Phone Number',
    subtitle: '+63 9271349238',
  },
};
